module.exports = __webpack_public_path__ + "static/media/icon_email.c0dc4c61.svg";